import React, { useEffect } from 'react';
import { notificationEnabled } from '../../stringConstants';
import { SuccessTick } from '../../assets/img';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);

function NotificationsEnabled({ show, close, serviceName, athlete }) {
  let fullName = (athlete && athlete.first_name + ' ' + athlete.last_name) || '';

  useEffect(() => {
    if (show) {
      MySwal
        .fire({
          title: "",
          html: alertContainer(),
          showConfirmButton: false,
          showCancelButton: false,
        });
    } else {
      MySwal
        .close();
    };
  }, [show]);


  const alertContainer = () => {
    return (
      <div className="px-4" >
        <h5 className="text-primary-color font-sf-medium">Training Notifications Enabled</h5>

        <small className="text-xs text-t-gray font-sf-regular">
          {notificationEnabled(serviceName, fullName)}
        </small>

        <div className="flex justify-center">
          <img alt="" src={SuccessTick} className="rounded object-cover my-5 self-center h-20 w-20" />
        </div>

        <div className="flex justify-center my-4">
          <button
            onClick={close}
            className="rounded-md border border-light-gray text-xs py-3 w-full md:w-32 bg-primary-color hover:text-gray-400 text-white font-normal my-3 md:my-0">
            Close
          </button>
        </div>
      </div >
    )
  };
  return (<div></div>);
}

export default NotificationsEnabled;
